// Pure math for the download-progress percentage shown next to the
// 'downloading' label. Kept import-free so the unit test needs no backend.

/** `permille` (0-1000) -> whole percent (0-100), as shown to the user. */
export function permilleToPercent(permille: number): number {
  return Math.floor(permille / 10)
}
